export function PlayIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3.00037L20 12.0004L6 21.0004V3.00037Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.01792"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PauseIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 4H16C15.4477 4 15 4.44772 15 5V19C15 19.5523 15.4477 20 16 20H18C18.5523 20 19 19.5523 19 19V5C19 4.44772 18.5523 4 18 4Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4H6C5.44772 4 5 4.44772 5 5V19C5 19.5523 5.44772 20 6 20H8C8.55228 20 9 19.5523 9 19V5C9 4.44772 8.55228 4 8 4Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function VolumeLoudIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7852 5L6.78516 9H2.78516V15H6.78516L11.7852 19V5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.01792"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3252 8.46008C17.2626 9.39772 17.7891 10.6693 17.7891 11.9951C17.7891 13.3209 17.2626 14.5924 16.3252 15.5301"
        stroke="currentColor"
        strokeWidth="2.01792"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8545 4.93018C21.7292 6.80545 22.7824 9.34853 22.7824 12.0002C22.7824 14.6518 21.7292 17.1949 19.8545 19.0702"
        stroke="currentColor"
        strokeWidth="2.01792"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function VolumeSoftIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.999 5L5.99902 9H1.99902V15H5.99902L10.999 19V5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.54 8.45996C16.4774 9.3976 17.004 10.6691 17.004 11.995C17.004 13.3208 16.4774 14.5923 15.54 15.53"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MuteIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 5L6 9H2V15H6L11 19V5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 9L16 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 9L22 15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HdIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_167_56)">
        <path
          d="M21.4824 5.09943H4.00698C2.62821 5.09943 1.5105 6.05072 1.5105 7.2242V17.8481C1.5105 19.0216 2.62821 19.9728 4.00698 19.9728H21.4824C22.8611 19.9728 23.9789 19.0216 23.9789 17.8481V7.2242C23.9789 6.05072 22.8611 5.09943 21.4824 5.09943Z"
          stroke="white"
          strokeWidth="2.08333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.78226 16.3652V9.00494H7.78047V11.8801H10.4256V9.00494H12.4238V16.3652H10.4256V13.4901H7.78047V16.3652H5.78226ZM16.2046 16.3652H13.3726V9.00494H16.1758C16.9329 9.00494 17.587 9.15229 18.1381 9.44699C18.6916 9.73929 19.118 10.161 19.4175 10.712C19.7194 11.2607 19.8704 11.9184 19.8704 12.6851C19.8704 13.4518 19.7206 14.1107 19.4211 14.6617C19.1216 15.2104 18.6975 15.6321 18.1489 15.9268C17.6002 16.2191 16.9521 16.3652 16.2046 16.3652ZM15.3708 14.6689H16.1327C16.4969 14.6689 16.8072 14.6102 17.0635 14.4928C17.3223 14.3754 17.5187 14.173 17.6529 13.8855C17.7895 13.5979 17.8578 13.1978 17.8578 12.6851C17.8578 12.1724 17.7883 11.7722 17.6493 11.4847C17.5128 11.1972 17.3115 10.9948 17.0455 10.8774C16.782 10.76 16.4585 10.7013 16.0752 10.7013H15.3708V14.6689Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_167_56">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(0.244629 0.0361328)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function RewindIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1552 6.91614V5.50786C15.014 5.74792 15.8301 6.13955 16.5629 6.67101C17.9922 7.70767 19.0143 9.21116 19.4525 10.9215C19.8908 12.6319 19.7176 14.4417 18.963 16.0379C18.2084 17.6342 16.9197 18.9166 15.3198 19.6634C13.7198 20.4102 11.9093 20.5745 10.201 20.1279C8.49281 19.6813 6.99433 18.6518 5.96468 17.2175C4.93503 15.7832 4.43891 14.0341 4.56212 12.2728C4.68533 10.5115 5.42011 8.84854 6.63943 7.57153C7.02453 7.16821 7.00976 6.52906 6.60643 6.14395C6.20311 5.75884 5.56395 5.77362 5.17885 6.17694C3.63438 7.79449 2.70366 9.90086 2.5476 12.1319C2.39153 14.3629 3.01994 16.5783 4.32417 18.3952C5.6284 20.212 7.52646 21.516 9.69021 22.0817C11.854 22.6474 14.1474 22.4393 16.1739 21.4933C18.2005 20.5473 19.8328 18.923 20.7887 16.9011C21.7446 14.8791 21.9639 12.5868 21.4088 10.4203C20.8537 8.2538 19.559 6.34938 17.7486 5.03628C16.667 4.25183 15.442 3.70788 14.1552 3.42798V1.51626C14.1552 1.31799 13.9371 1.19712 13.7689 1.3022L9.44904 4.00214C9.29085 4.10101 9.29085 4.33139 9.44904 4.43026L13.7689 7.1302C13.9371 7.23529 14.1552 7.11441 14.1552 6.91614ZM10.1197 15.7403V9.13115H8.80623L7.17009 10.167V11.4063L8.6836 10.4575H8.72233V15.7403H10.1197ZM12.849 15.4756C13.2491 15.7467 13.7268 15.8833 14.2818 15.8855C14.8369 15.8855 15.3134 15.7499 15.7114 15.4789C16.1094 15.2078 16.4149 14.8151 16.6279 14.301C16.8431 13.7868 16.9506 13.1672 16.9506 12.4422C16.9528 11.7214 16.8463 11.1083 16.6311 10.6027C16.416 10.095 16.1084 9.70772 15.7082 9.44095C15.3102 9.17418 14.8347 9.04079 14.2818 9.04079C13.7289 9.04079 13.2524 9.17418 12.8522 9.44095C12.4542 9.70557 12.1476 10.0917 11.9325 10.5995C11.7195 11.1072 11.613 11.7214 11.613 12.4422C11.6109 13.165 11.7163 13.7836 11.9293 14.2977C12.1444 14.8119 12.451 15.2046 12.849 15.4756ZM15.1886 14.1557C14.9627 14.5365 14.6605 14.7269 14.2818 14.7269C14.0301 14.7269 13.8107 14.643 13.6235 14.4752C13.4363 14.3053 13.2911 14.0514 13.1878 13.7136C13.0867 13.3737 13.0362 12.9499 13.0362 12.4422C13.0383 11.6913 13.1523 11.1276 13.3782 10.7512C13.6041 10.3747 13.9053 10.1864 14.2818 10.1864C14.5335 10.1864 14.7519 10.2703 14.9369 10.4381C15.1241 10.6059 15.2682 10.8566 15.3693 11.19C15.4726 11.5235 15.5242 11.9409 15.5242 12.4422C15.5264 13.2037 15.4145 13.7749 15.1886 14.1557Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ForwardIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0802 7.36353V5.95525C9.22135 6.1953 8.40521 6.58694 7.67247 7.1184C6.2432 8.15505 5.22107 9.65854 4.78282 11.3689C4.34456 13.0793 4.51772 14.8891 5.27236 16.4853C6.027 18.0816 7.31568 19.364 8.9156 20.1108C10.5155 20.8576 12.3261 21.0219 14.0343 20.5753C15.7425 20.1287 17.241 19.0992 18.2707 17.6649C19.3003 16.2306 19.7964 14.4815 19.6732 12.7202C19.55 10.9589 18.8152 9.29593 17.5959 8.01892C17.2108 7.61559 17.2256 6.97644 17.6289 6.59134C18.0322 6.20623 18.6714 6.221 19.0565 6.62433C20.601 8.24188 21.5317 10.3482 21.6878 12.5793C21.8438 14.8103 21.2154 17.0257 19.9112 18.8426C18.607 20.6594 16.7089 21.9634 14.5451 22.5291C12.3814 23.0948 10.088 22.8867 8.06142 21.9407C6.03485 20.9947 4.40253 19.3704 3.44665 17.3484C2.49078 15.3265 2.27144 13.0342 2.82657 10.8677C3.38169 8.70119 4.67638 6.79676 6.4868 5.48366C7.56834 4.69922 8.79332 4.15527 10.0802 3.87537V1.96365C10.0802 1.76538 10.2983 1.64451 10.4664 1.74959L14.7863 4.44953C14.9445 4.5484 14.9445 4.77878 14.7863 4.87765L10.4664 7.57759C10.2983 7.68267 10.0802 7.5618 10.0802 7.36353ZM9.97561 16.1882V9.57914H8.66218L7.02604 10.615V11.8543L8.53955 10.9055H8.57828V16.1882H9.97561ZM12.7049 15.9236C13.1051 16.1947 13.5827 16.3313 14.1378 16.3335C14.6928 16.3335 15.1694 16.1979 15.5674 15.9269C15.9654 15.6558 16.2709 15.2631 16.4839 14.749C16.699 14.2348 16.8066 13.6152 16.8066 12.8902C16.8087 12.1694 16.7022 11.5563 16.4871 11.0507C16.272 10.543 15.9643 10.1557 15.5641 9.88895C15.1661 9.62217 14.6907 9.48879 14.1378 9.48879C13.5849 9.48879 13.1083 9.62217 12.7082 9.88895C12.3102 10.1536 12.0036 10.5397 11.7884 11.0475C11.5754 11.5552 11.469 12.1694 11.469 12.8902C11.4668 13.613 11.5722 14.2316 11.7852 14.7457C12.0003 15.2599 12.3069 15.6526 12.7049 15.9236ZM15.0446 14.6037C14.8187 14.9845 14.5164 15.1749 14.1378 15.1749C13.8861 15.1749 13.6666 15.091 13.4794 14.9232C13.2923 14.7533 13.147 14.4994 13.0438 14.1616C12.9427 13.8217 12.8921 13.3979 12.8921 12.8902C12.8943 12.1393 13.0083 11.5756 13.2342 11.1992C13.4601 10.8227 13.7613 10.6344 14.1378 10.6344C14.3895 10.6344 14.6078 10.7183 14.7929 10.8861C14.98 11.0539 15.1242 11.3046 15.2253 11.638C15.3286 11.9715 15.3802 12.3889 15.3802 12.8902C15.3824 13.6517 15.2705 14.2229 15.0446 14.6037Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PictureInIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.46582 5.32959V10.3296M8.46582 10.3296H3.46582M8.46582 10.3296L2.46582 4.32959M21.4658 10.3296V7.32959C21.4658 6.16959 20.6258 5.32959 19.4658 5.32959H12.4658M3.46582 14.3296V16.3296C3.46582 17.3796 4.41582 18.3296 5.46582 18.3296H8.46582"
        stroke="currentColor"
        strokeWidth="2.0142"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4668 14.3296H14.4668C13.3622 14.3296 12.4668 15.225 12.4668 16.3296V19.3296C12.4668 20.4342 13.3622 21.3296 14.4668 21.3296H20.4668C21.5714 21.3296 22.4668 20.4342 22.4668 19.3296V16.3296C22.4668 15.225 21.5714 14.3296 20.4668 14.3296Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.0142"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PictureOutIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10.3292V7.32922C21 6.16922 20.16 5.32922 19 5.32922H12M3 14.3292V16.3292C3 17.3792 3.95 18.3292 5 18.3292H8"
        stroke="currentColor"
        strokeWidth="2.0142"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.999 14.3304H13.999C12.8945 14.3304 11.999 15.2259 11.999 16.3304V19.3304C11.999 20.435 12.8945 21.3304 13.999 21.3304H19.999C21.1036 21.3304 21.999 20.435 21.999 19.3304V16.3304C21.999 15.2259 21.1036 14.3304 19.999 14.3304Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.0142"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.18262 9.10254V4.10254M2.18262 4.10254L8.18262 10.1025M2.18262 4.10254H4.68262H7.18262"
        stroke="currentColor"
        strokeWidth="2.0142"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LightbulbIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.65354 21.5953V18.1286C8.78687 17.3287 8.62687 15.3022 6.92021 13.5956C5.21354 11.8889 4.87576 8.7954 4.92021 7.46198C5.02687 2.44864 10.1202 1.37309 12.6535 1.46198C21.5069 3.91531 18.6535 11.1953 16.1202 14.5286L14.9202 17.7286L15.1869 20.662L14.3869 22.1286L12.6535 22.7953V23.7286L11.9869 24.1286L10.5202 23.7286V22.7953L9.85354 22.3953L8.65354 21.5953Z"
        fill="white"
      />
      <path
        d="M11.8096 0.799805C7.93763 0.799805 4.2002 3.81007 4.2002 8.07111C4.2002 10.7582 5.24618 12.466 6.21242 13.8332C6.29795 13.9542 6.38237 14.0724 6.46523 14.1883C7.31849 15.3827 8.00513 16.3438 8.00513 17.7754V21.2876C8.00513 22.281 8.82889 23.0437 9.76124 23.0437H10.054C10.054 24.0064 10.8473 24.7998 11.8101 24.7998C12.7728 24.7998 13.5662 24.0065 13.5662 23.0437H13.8589C14.7913 23.0437 15.6151 22.2811 15.6151 21.2876V17.7754C15.6151 16.3441 16.3016 15.3831 17.1547 14.1887C17.2377 14.0726 17.3222 13.9543 17.4078 13.8332C18.3736 12.4658 19.4195 10.7582 19.4195 8.07111C19.4195 3.81018 15.6818 0.799805 11.8096 0.799805ZM11.8096 1.97057C15.0761 1.97057 18.2486 4.49866 18.2486 8.07111C18.2486 10.4661 17.3922 11.8316 16.4559 13.1562C16.376 13.2693 16.295 13.3823 16.2139 13.4957C15.4416 14.5741 14.6485 15.6817 14.4803 17.1898H9.13884C8.97076 15.6822 8.17785 14.5748 7.40573 13.4964C7.32441 13.3828 7.24332 13.2696 7.16321 13.1562C6.22722 11.8312 5.37081 10.4657 5.37081 8.07072C5.37081 4.49831 8.54323 1.97057 11.8096 1.97057ZM9.17559 18.3604H14.4439V19.5312H9.17559V18.3604ZM9.17559 20.7018H14.4439V21.2871C14.4439 21.6389 14.1616 21.8725 13.8585 21.8725H9.76105C9.45803 21.8725 9.17575 21.6389 9.17575 21.2871L9.17559 20.7018ZM11.2243 23.0433H12.395C12.395 23.3778 12.144 23.6286 11.8097 23.6286C11.4752 23.6286 11.2243 23.3776 11.2243 23.0433Z"
        fill="#5300EC"
      />
      <path
        d="M11.8096 0.799805C7.93763 0.799805 4.2002 3.81007 4.2002 8.07111C4.2002 10.7582 5.24618 12.466 6.21242 13.8332C6.29795 13.9542 6.38237 14.0724 6.46523 14.1883C7.31849 15.3827 8.00513 16.3438 8.00513 17.7754V21.2876C8.00513 22.281 8.82889 23.0437 9.76124 23.0437H10.054C10.054 24.0064 10.8473 24.7998 11.8101 24.7998C12.7728 24.7998 13.5662 24.0065 13.5662 23.0437H13.8589C14.7913 23.0437 15.6151 22.2811 15.6151 21.2876V17.7754C15.6151 16.3441 16.3016 15.3831 17.1547 14.1887C17.2377 14.0726 17.3222 13.9543 17.4078 13.8332C18.3736 12.4658 19.4195 10.7582 19.4195 8.07111C19.4195 3.81018 15.6818 0.799805 11.8096 0.799805ZM11.8096 1.97057C15.0761 1.97057 18.2486 4.49866 18.2486 8.07111C18.2486 10.4661 17.3922 11.8316 16.4559 13.1562C16.376 13.2693 16.295 13.3823 16.2139 13.4957C15.4416 14.5741 14.6485 15.6817 14.4803 17.1898H9.13884C8.97076 15.6822 8.17785 14.5748 7.40573 13.4964C7.32441 13.3828 7.24332 13.2696 7.16321 13.1562C6.22722 11.8312 5.37081 10.4657 5.37081 8.07072C5.37081 4.49831 8.54323 1.97057 11.8096 1.97057ZM9.17559 18.3604H14.4439V19.5312H9.17559V18.3604ZM9.17559 20.7018H14.4439V21.2871C14.4439 21.6389 14.1616 21.8725 13.8585 21.8725H9.76105C9.45803 21.8725 9.17575 21.6389 9.17575 21.2871L9.17559 20.7018ZM11.2243 23.0433H12.395C12.395 23.3778 12.144 23.6286 11.8097 23.6286C11.4752 23.6286 11.2243 23.3776 11.2243 23.0433Z"
        stroke="#5300EC"
      />
    </svg>
  )
}

export function PaperIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.33643 3.73236C4.33643 2.54369 5.30003 1.58008 6.4887 1.58008H14.7442C15.315 1.58008 15.8625 1.80684 16.2661 2.21047L18.326 4.27038L20.0066 6.37115C20.3119 6.75277 20.4782 7.22694 20.4782 7.71566V20.9502C20.4782 22.1389 19.5146 23.1025 18.326 23.1025H12.4073H6.4887C5.30003 23.1025 4.33643 22.1389 4.33643 20.9502V3.73236Z"
        fill="white"
      />
      <mask
        id="path-2-outside-1_317_10"
        maskUnits="userSpaceOnUse"
        x="2.26025"
        y="-0.496094"
        width="20"
        height="25"
        fill="black"
      >
        <rect fill="white" x="2.26025" y="-0.496094" width="20" height="25" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9216 5.11343L17.9291 5.12085L17.9366 5.12815L20.2755 7.38785H14.5765V1.7683L17.9216 5.11343ZM13.3569 1.72353H6.61422C5.43546 1.72353 4.47988 2.67911 4.47988 3.85787V20.5423C4.47988 21.7211 5.43545 22.6767 6.61422 22.6767H18.2003C19.3791 22.6767 20.3347 21.7211 20.3347 20.5423V8.60747H14.3732C13.8119 8.60747 13.3569 8.15244 13.3569 7.59112V1.72353ZM3.26025 3.85787C3.26025 2.00553 4.76188 0.503906 6.61422 0.503906H14.5935C14.8774 0.503906 15.1497 0.616704 15.3505 0.817485L18.784 4.25103L21.2276 6.61188C21.4364 6.81362 21.5543 7.09151 21.5543 7.38184V20.5423C21.5543 22.3947 20.0527 23.8963 18.2003 23.8963H6.61422C4.76187 23.8963 3.26025 22.3947 3.26025 20.5423V3.85787Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9216 5.11343L17.9291 5.12085L17.9366 5.12815L20.2755 7.38785H14.5765V1.7683L17.9216 5.11343ZM13.3569 1.72353H6.61422C5.43546 1.72353 4.47988 2.67911 4.47988 3.85787V20.5423C4.47988 21.7211 5.43545 22.6767 6.61422 22.6767H18.2003C19.3791 22.6767 20.3347 21.7211 20.3347 20.5423V8.60747H14.3732C13.8119 8.60747 13.3569 8.15244 13.3569 7.59112V1.72353ZM3.26025 3.85787C3.26025 2.00553 4.76188 0.503906 6.61422 0.503906H14.5935C14.8774 0.503906 15.1497 0.616704 15.3505 0.817485L18.784 4.25103L21.2276 6.61188C21.4364 6.81362 21.5543 7.09151 21.5543 7.38184V20.5423C21.5543 22.3947 20.0527 23.8963 18.2003 23.8963H6.61422C4.76187 23.8963 3.26025 22.3947 3.26025 20.5423V3.85787Z"
        fill="#5300EC"
      />
      <path
        d="M17.9291 5.12085L17.8442 5.20572L17.8457 5.20715L17.9291 5.12085ZM17.9216 5.11343L17.8368 5.19829L17.8368 5.19829L17.9216 5.11343ZM17.9366 5.12815L17.8532 5.21445L17.8532 5.21445L17.9366 5.12815ZM20.2755 7.38785V7.50785H20.5724L20.3588 7.30155L20.2755 7.38785ZM14.5765 7.38785H14.4565V7.50785H14.5765V7.38785ZM14.5765 1.7683L14.6614 1.68345L14.4565 1.4786V1.7683H14.5765ZM13.3569 1.72353H13.4769V1.60353H13.3569V1.72353ZM20.3347 8.60747H20.4547V8.48747H20.3347V8.60747ZM15.3505 0.817485L15.2657 0.902338L15.3505 0.817485ZM18.784 4.25103L18.6992 4.33589L18.7007 4.33733L18.784 4.25103ZM21.2276 6.61188L21.1442 6.69818V6.69818L21.2276 6.61188ZM18.0139 5.036L18.0065 5.02858L17.8368 5.19829L17.8442 5.20571L18.0139 5.036ZM18.02 5.04185L18.0124 5.03456L17.8457 5.20715L17.8532 5.21445L18.02 5.04185ZM20.3588 7.30155L18.02 5.04185L17.8532 5.21445L20.1921 7.47415L20.3588 7.30155ZM14.5765 7.50785H20.2755V7.26785H14.5765V7.50785ZM14.4565 1.7683V7.38785H14.6965V1.7683H14.4565ZM18.0065 5.02858L14.6614 1.68345L14.4917 1.85315L17.8368 5.19829L18.0065 5.02858ZM13.3569 1.60353H6.61422V1.84353H13.3569V1.60353ZM6.61422 1.60353C5.36918 1.60353 4.35988 2.61283 4.35988 3.85787H4.59988C4.59988 2.74538 5.50173 1.84353 6.61422 1.84353V1.60353ZM4.35988 3.85787V20.5423H4.59988V3.85787H4.35988ZM4.35988 20.5423C4.35988 21.7874 5.36918 22.7967 6.61422 22.7967V22.5567C5.50173 22.5567 4.59988 21.6548 4.59988 20.5423H4.35988ZM6.61422 22.7967H18.2003V22.5567H6.61422V22.7967ZM18.2003 22.7967C19.4454 22.7967 20.4547 21.7874 20.4547 20.5423H20.2147C20.2147 21.6548 19.3128 22.5567 18.2003 22.5567V22.7967ZM20.4547 20.5423V8.60747H20.2147V20.5423H20.4547ZM20.3347 8.48747H14.3732V8.72747H20.3347V8.48747ZM14.3732 8.48747C13.8782 8.48747 13.4769 8.08616 13.4769 7.59112H13.2369C13.2369 8.21871 13.7457 8.72747 14.3732 8.72747V8.48747ZM13.4769 7.59112V1.72353H13.2369V7.59112H13.4769ZM6.61422 0.383906C4.6956 0.383906 3.14025 1.93926 3.14025 3.85787H3.38025C3.38025 2.0718 4.82815 0.623906 6.61422 0.623906V0.383906ZM14.5935 0.383906H6.61422V0.623906H14.5935V0.383906ZM15.4354 0.732632C15.2121 0.509347 14.9092 0.383906 14.5935 0.383906V0.623906C14.8456 0.623906 15.0874 0.724061 15.2657 0.902338L15.4354 0.732632ZM18.8689 4.16618L15.4354 0.732632L15.2657 0.902338L18.6992 4.33588L18.8689 4.16618ZM21.311 6.52558L18.8674 4.16473L18.7007 4.33733L21.1442 6.69818L21.311 6.52558ZM21.6743 7.38184C21.6743 7.05897 21.5432 6.74993 21.311 6.52558L21.1442 6.69818C21.3296 6.87731 21.4343 7.12405 21.4343 7.38184H21.6743ZM21.6743 20.5423V7.38184H21.4343V20.5423H21.6743ZM18.2003 24.0163C20.119 24.0163 21.6743 22.461 21.6743 20.5423H21.4343C21.4343 22.3284 19.9864 23.7763 18.2003 23.7763V24.0163ZM6.61422 24.0163H18.2003V23.7763H6.61422V24.0163ZM3.14025 20.5423C3.14025 22.461 4.6956 24.0163 6.61422 24.0163V23.7763C4.82815 23.7763 3.38025 22.3284 3.38025 20.5423H3.14025ZM3.14025 3.85787V20.5423H3.38025V3.85787H3.14025Z"
        fill="#5300EC"
        mask="url(#path-2-outside-1_317_10)"
      />
    </svg>
  )
}
